const featuredContentConstantsEn = {
  featuredContentPageBreadcrumb: 'Featured Content',
  featuredContentPageTitle: 'Featured Content',
  manageFeaturedContentBreadcrumb: 'Manage Featured Content',
  manageFeaturedContentPageTitle: 'Manage Featured Content',
  updateFeaturedContentButton: 'Update Featured Content',
  addFeaturedContentDialogTitle: 'Add a Playlist',
  choosePlaylistLabel: 'Choose a Playlist',
  editFeaturedContentDialogTitle: 'Edit a Playlist',
  editFeaturedContentDialogButton: 'Save Changes',
  addFeaturedContentDialogButton: 'Add new Playlist',
  emptyPlaylistNameErrorMessage: 'Please add a playlist name',
  manageFeaturedDeleteButton: 'Delete',
  errorSnackbar: 'Something went Wrong !',
  successSnackbar: 'Saved Successfully !',
  landingPageTitle: 'Landing Page',
  homePageTitle: 'Home Page',
  latestVideoPage: 'Latest Videos Page',
  contentIdeasPage:'Content Ideas',
  latestVideoPlaylistNameColumn: 'Playlist Name',
  latestVideoPlaylistIdColumn: 'Playlist Id',
};

export default featuredContentConstantsEn;
